<template>
  <v-sheet max-height="200" style="overflow-y: auto">
    <v-checkbox
      v-model="selection"
      :label="filter.name"
      density="compact"
      hide-details
    />
  </v-sheet>
</template>
<script lang="ts">
import type { CheckboxFilter } from "./types";
import { useFilterInput } from "./store";

export default defineComponent({
  props: {
    filter: { type: Object as PropType<CheckboxFilter>, required: true },
  },
  setup(props) {
    const { useValue } = useFilterInput(props.filter as any);

    const selection = useValue<boolean>(0, false);

    return {
      selection,
    };
  },
});
</script>
